import './select-tenant.scss'

import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetcher } from '../../api'
import { Tenant } from '../../pages/Tenants/models'
import { getEnvironmentHost } from '../../util/environment'
import { sortStrings } from '../../util/sorters/sort-strings'
import { Switch } from '../Switch'

const { Option } = Select

interface Props {
  onTenantSelected: (tenantId: number) => void
  tenantKey?: string
  allowClear?: boolean
}

export const SelectTenant = ({ onTenantSelected, tenantKey = 'domain', allowClear = false }: Props) => {
  const [tenants, setTenants] = useState<Tenant[]>([])
  const [isCustomerOnly, setIsCustomerOnly] = useState(false)

  const { data: apiTenants } = useSWR<Tenant[]>('/tenants', fetcher)

  useEffect(() => {
    apiTenants && setTenants(isCustomerOnly ? apiTenants.filter(isCustomer) : apiTenants)
  }, [apiTenants, isCustomerOnly])

  return (
    <Row className="select-tenant" alignItemsCenter>
      <label htmlFor="select-tenant">Current Tenant</label>
      <Select
        autoFocus
        showSearch
        id="select-tenant"
        placeholder="Select a tenant"
        optionFilterProp="children"
        filterOption={filterOption}
        onChange={onTenantSelected}
        allowClear={allowClear}
      >
        {tenants.sort(byName).map((tenant) => (
          <Option key={tenant?.domain} value={tenant[tenantKey]} title={getEnvironmentHost({ domain: tenant?.domain })}>
            {`${tenant?.name}  ( ${tenant?.domain} | ${tenant?.id} )`}
          </Option>
        ))}
      </Select>
      <Switch label="Customers only" onChange={setIsCustomerOnly} />
    </Row>
  )
}

const isCustomer = ({ isTrial, isDemo }: Tenant) => !isTrial && !isDemo
const byName = (firstTenant: Tenant, secondTenant: Tenant) => sortStrings(firstTenant.name, secondTenant.name)
const filterOption = (searchInput: string, searchOption: any) =>
  searchOption.children.toLowerCase().includes(searchInput.toLowerCase())
